import {
  Button,
  Chip,
  IconButton,
  Typography as JoyTypo,
  Switch,
  Tooltip,
} from "@mui/joy";
import { AppBar, Box, FormControlLabel } from "@mui/material";
import { RouterConfig } from "../config/routerConfig";
import { ReactElement } from "react";
import { proEnabled } from "../../constants";
import { setFormOpen, setPro } from "../../reducers/rhapsody";
import { AvatarMenu } from "../avatarMenu/avatarMenu";
import { CreateCenter } from "../createCenter/createCenter";
import { IntercomButton } from "../intercom/intercomButton";
import { IntercomConfig } from "../intercom/intercomConfig";
import { NerdImpersonate } from "../nerdImpersonate/nerdImpersonate";
import { useNavigate } from "react-router-dom";
import { usePro } from "../usePro/usePro";
import { useDispatch } from "react-redux";
/**
 *
 * @returns {ReactElement} MainAppBar page
 */
export function MainAppBar() {
  const navigate = useNavigate();
  const pro = usePro();
  const dispatch = useDispatch();
  return (
    <AppBar
      variant="outlined"
      sx={{
        height: 48,
        background: "#081D3A",
        width: "100%",
        display: "flex",
        alignItems: "center",
        gap: 1,
        flexDirection: "row",
        pl: 1,
        pr: 1,
        justifyContent: "space-between",
        overflow: "hidden",
      }}
    >
      <IntercomConfig />
      <IntercomButton />
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Button
          onClick={() => navigate("/")}
          size="sm"
          variant="plain"
          sx={{ color: "rgba(255,255,255,0)" }}
        >
          <img
            src="https://storage.googleapis.com/wid-rhapsody/images/logo_main-white.png"
            height="32"
          />
        </Button>
        {proEnabled && pro !== undefined ? (
          <>
            {!pro ? (
              <Chip
                onClick={() =>
                  dispatch(setFormOpen({ formID: "upgradeOpen", isOpen: true }))
                }
                startDecorator={<i className="fa-solid fa-sparkles"></i>}
                color="info"
                size="sm"
              >
                Get Pro{" "}
              </Chip>
            ) : (
              <Chip color="info" size="sm">
                Pro
              </Chip>
            )}
          </>
        ) : (
          []
        )}
      </Box>
      {/* <Typography
                level="h6"
                sx={{
                  fontFamily: "neonoir",
                  fontWeight: 700,
                  color: "white",
                  fontSize: 26,
                  animation: `pulsate 0.11s ease-in-out infinite alternate`,
                  textShadow: `0 0 7px #fff,
    0 0 10px #fff,
    0 0 21px #fff,
    0 0 42px #2196f3,
    0 0 82px #2196f3,
    0 0 92px #2196f3,
    0 0 102px #2196f3,
    0 0 151px #2196f3;`,
                }}
              >
                for musicians
              </Typography> */}
      <Box
        sx={{
          display: "flex",
          gap: 1,
          alignItems: "center",
        }}
      >
        {/* <NerdAppsMenuWrapper key={"NerdAppsMenuWrapper"} /> */}
        {/* <NerdUserMenu key={"myAccountButton"} /> */}

        <NerdImpersonate key={"NerdImpersonate"} />
        <Tooltip title="My QR Code">
          <IconButton
            size="sm"
            variant="soft"
            color="info"
            onClick={() => navigate(RouterConfig.qrCode)}
            aria-label="My QR Code"
          >
            <i className="fa-regular fa-qrcode"></i>
          </IconButton>
        </Tooltip>
        <CreateCenter />

        <AvatarMenu />
      </Box>
    </AppBar>
  );
}
